<template>
    <div
        :class="[
            'web-community-discussion-list-root',
            {
                isPC: isPC,
                white: theme === THEME.WHITE,
                black: theme === THEME.BLACK,
                'hide-discussion': !showDiscussion,
                ja: contentLang === LANG.LANG_JA
            }
        ]"
    >
        <!-- isPreRender 处理预渲染下的兼容，防止空注释节点 -->
        <div v-if="isPreRender" key="hideContent"></div>
        <div v-else-if="showData" key="showContent" class="data-container">
            <a v-if="showDiscussion" href="javascript:;" class="discussion-container" @click="onClickDiscussion()">
                <div class="title bold">{{ discussionTitle }}</div>
                <div v-if="showBrowseCount && discussionBrowseCount" class="browse-count">{{discussionBrowseCount}}</div>
            </a>
            <div ref="swiperRef" class="basic-swiper-main">
                <div class="swiper-wrapper">
                    <!-- 子项 -->
                    <div
                        :class="{
                            'swiper-slide': true,
                            'list-item': true
                        }"
                        v-for="item in discussionFeedList"
                        :key="item.id"
                    >
                        <a
                            href="javascript:;"
                            @click="onClickDiscussionFeed(item)"
                        >
                            <div class="user">
                                <div class="avatar" :style="`backgroundImage: url(${item.avator})`"></div>
                                <div class="name-publish-time">
                                    <div class="name bold">{{ item.nick }}</div>
                                    <div class="publish-time">{{ formatTime(item.time) }}</div>
                                </div>
                            </div>
                            <div class="content-title bold" :class="[{ 'has-img': item.imgUrl }]">{{ item.title }}</div>
                            <div class="content-stock-info" v-if="item.stockInfos && item.stockInfos.length">
                                <a
                                    href="javascript:;"
                                    v-for="stockInfo in item.stockInfos"
                                    :key="stockInfo.stockId"
                                    @click="onClickStockInfo($event, stockInfo)"
                                    >${{ stockInfo.stockSymbol }}$&nbsp;</a
                                >
                            </div>
                            <div
                                class="content-description"
                                :class="[
                                    {
                                        'has-stock-info': item.stockInfos && item.stockInfos.length,
                                        'has-img': item.imgUrl,
                                    }
                                ]"
                                v-html="formatText(item.texts)"
                            ></div>
                        </a>
                        <div v-if="item.imgUrl" style="display: flex; justify-content: center;">
                            <img @click="preview(item.imgUrl)" :src="item.imgUrl" alt="img" class="img-item" />
                        </div>
                    </div>
                </div>
                <div ref="paginationRef" class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</template>

<script >
/* global FEGORender */
import { computed, ref, onMounted, defineProps } from 'vue-demi';
import CONSTANTS from '../constants/index';
import useSwiper from '../composables/useSwiper';
import { ImagePreview } from '@futuweb/moo-ui';
import '@futuweb/moo-ui/es/image-preview/style/css';
import useFormat from '../composables/useFormat';
import useRenderFeedList from '../composables/useRenderFeed';
import useRenderClick from '../composables/useRenderClick';
import useAutoplay from '../composables/useAutoplay';
const __sfc_main = {};
__sfc_main.props = {
  discussionId: {
    type: [Number, String],
    default: 0
  },
  theme: {
    type: String,
    default: 'white'
  },
  showDiscussion: {
    type: Boolean,
    default: true
  },
  showBrowseCount: {
    type: Boolean,
    default: true
  },
  contentLang: {
    type: Number
  },
  contentNum: {
    type: Number,
    default: 3
  },
  orderType: {
    type: Number,
    default: 1
  },
  customFeedList: {
    type: Array,
    default: () => [{
      feedId: 0
    }]
  },
  autoplay: {
    type: Boolean,
    default: false
  },
  autoplayDelay: {
    type: Number,
    default: 3
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    usePageType,
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const {
    isPreRender
  } = useEnv();
  const props = __props;
  const THEME = CONSTANTS.THEME;
  const LANG = CONSTANTS.LANG;
  const {
    formatTime,
    formatText,
    formatBrowseCountStr
  } = useFormat(props);
  const {
    discussionInfo,
    getData,
    discussionFeedList,
    isCustomFeedId
  } = useRenderFeedList(props);
  const {
    onClickDiscussion,
    onClickDiscussionFeed,
    onClickStockInfo
  } = useRenderClick(props);
  const showData = computed(() => {
    if (isCustomFeedId.value) {
      return discussionFeedList.value && discussionFeedList.value.length;
    }
    return discussionInfo.value && discussionFeedList.value && discussionFeedList.value.length;
  });
  const discussionTitle = computed(() => {
    if (discussionInfo.value && discussionInfo.value.discussionTitle) {
      return discussionInfo.value.discussionTitle[CONSTANTS.LANG_NUM_STRING_MAP[props.contentLang]];
    }
    return '';
  });
  const discussionBrowseCount = computed(() => {
    if (discussionInfo.value && discussionInfo.value.browseCount) {
      return formatBrowseCountStr(discussionInfo.value.browseCount);
    }
    return '';
  });
  const swiperRef = ref(null);
  const paginationRef = ref(null);
  const swiperOptions = computed(() => ({
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    slides: discussionFeedList.value,
    autoplay: props.autoplay,
    autoplayDelay: props.autoplayDelay,
    allowTouchMove: true
  }));
  const {
    swiper
  } = useSwiper({
    el: swiperRef,
    paginationEl: paginationRef,
    options: swiperOptions
  });
  props.autoplay && swiperRef.value && useAutoplay(swiper, swiperRef);

  // 预览图片
  const preview = imgUrl => {
    ImagePreview({
      images: [imgUrl],
      zIndex: 2000,
      loop: false
    });
  };
  onMounted(async () => {
    await getData();
  });
  return {
    isPC,
    isPreRender,
    THEME,
    LANG,
    formatTime,
    formatText,
    discussionFeedList,
    onClickDiscussion,
    onClickDiscussionFeed,
    onClickStockInfo,
    showData,
    discussionTitle,
    discussionBrowseCount,
    swiperRef,
    paginationRef,
    preview
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
@import '../style/index.less';
.web-community-discussion-list-root {
    height: auto !important;
    .bold {
        font-weight: 700;
    }
    &.ja {
        .bold {
            font-weight: 700;
        }
    }

    background-color: #ffffff;
    .data-container {
        // padding: 0rem 0.4rem;
    }

    // 默认样式
    .discussion-container {
        padding: 0.4rem 0.3rem;
        background-color: #f4f7ff;
        display: block;
        border-radius: 0.1rem;
        .title {
            font-size: 0.36rem;
            color: #121212;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .browse-count {
            margin-top: 0.24rem;
            font-size: 0.2rem;
            color: #7a7a7a;
        }
    }

    // 黑肤颜色调整
    &.black {
        background-color: #0a0a0a;
        .discussion-container {
            background-color: #1b1f2a;
            .title {
                color: #e5e5e5;
            }
            .browse-count {
                color: #939393;
            }
        }
        .swiper-wrapper {
            .list-item {
                .user {
                    .name-publish-time {
                        .name {
                            color: #e5e5e5;
                        }
                        .publish-time {
                            color: #9b9b9e;
                        }
                    }
                }
                .content-title {
                    color: #e5e5e5;
                }
                .content-description {
                    color: #e5e5e5;
                }
                &::after {
                    background-color: #333;
                }
            }
        }
        .tip-container {
            color: #e5e5e5;
        }
    }

    // PC 尺寸调整
    &.isPC {
        .data-container {
            padding: 0;
        }
        .discussion-container {
            padding: 0.5rem 0.64rem;
            .title {
                font-size: 0.3rem;
            }
        }
        .swiper-wrapper {
            .list-item {
                padding: 0.5rem 0.4rem 0rem;
                position: relative;
                .user {
                    margin-bottom: 0.24rem;
                    .avatar {
                        width: 0.72rem;
                        height: 0.72rem;
                        border-radius: 0.36rem;
                        margin-right: 0.2rem;
                    }
                    .name-publish-time {
                        .name {
                            font-size: 0.24rem;
                            margin-bottom: 0.04rem;
                        }
                        .publish-time {
                            font-size: 0.2rem;
                        }
                    }
                }
                .content-title {
                    font-size: 0.3rem;
                    margin-bottom: 0.12rem;
                }
                .content-stock-info {
                    font-size: 0.2rem;
                }
                .content-description {
                    font-size: 0.24rem;
                    -webkit-line-clamp: 3;
                    &.has-img {
                        -webkit-line-clamp: 1;
                    }
                    // 有股票信息的情况下，少一行
                    &.has-stock-info {
                        -webkit-line-clamp: 2;
                    }
                }
                &:last-child {
                    &::after {
                        display: none;
                    }
                }
            }
        }
    }

    .tip-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 2rem;
    }
    .swiper-wrapper {
        .list-item {
            padding: 0.5rem 0.4rem 0rem;
            position: relative;
            display: block;
            .user {
                display: flex;
                align-items: center;
                margin-bottom: 0.32rem;
                .avatar {
                    flex-shrink: 0;
                    width: 0.72rem;
                    height: 0.72rem;
                    border-radius: 0.36rem;
                    margin-right: 0.2rem;
                    background-size: cover;
                }
                .name-publish-time {
                    min-width: 0;
                    .name {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        font-size: 0.28rem;
                        color: #262626;
                        margin-bottom: 0.06rem;
                    }
                    .publish-time {
                        font-size: 0.24rem;
                        color: #7a7a7a;
                    }
                }
            }
            .content-title {
                font-size: 0.36rem;
                color: #262626;
                margin-bottom: 0.14rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                word-break: break-word;
                &.has-img {
                    -webkit-line-clamp: 1;
                }
            }
            .content-stock-info {
                font-size: 0.26rem;
                color: rgba(14, 85, 201, 0.8);
                word-break: break-word;
                margin-bottom: 0.14rem;
                a {
                    color: rgba(14, 85, 201, 0.8);
                }
            }
            .content-description {
                font-size: 0.3rem;
                color: #262626;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                word-break: break-word;
                &.has-img {
                    -webkit-line-clamp: 1;
                }
                // 有股票信息的情况下，少一行
                &.has-stock-info {
                    -webkit-line-clamp: 4;
                }
                /deep/ .link {
                    color: #0e55c9cc;
                }

                /deep/ .stock {
                    color: #0e55c9cc;
                }
            }
            .img-item {
                width: 100%;
                height: 3rem;
                object-fit: contain;
                object-position: left;
                display: block;
            }
            &:last-child {
                &::after {
                    display: none;
                }
            }
        }
    }
}
</style>
